import { forwardRef, createElement } from 'react';

function IconLayout(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M14.5 20.5V22h-5v-1.5h5zm-9-2.5v2.25a.25.25 0 00.193.243l.057.007H8V22H5.75A1.75 1.75 0 014 20.25V18h1.5zM20 18v2.25A1.75 1.75 0 0118.25 22H16v-1.5h2.25a.25.25 0 00.243-.193l.007-.057V18H20zm0-5.25v3.75h-1.5v-3.75H20zm-14.5 0v3.75H4v-3.75h1.5zM16.326 2.676a1.752 1.752 0 012.349-.113l.125.113.594.593c.59.589.676 1.502.21 2.216l-.094.131-.115.128-7.504 7.5-3 .008-.078-3.067 7.513-7.509zm-.796 2.916l-5.202 5.199.025.957.914-.002 5.209-5.207-.946-.947zM20 9v2.25h-1.5V9H20zM5.5 7.5v3.75H4V7.5h1.5zM8 2v1.5H5.75a.25.25 0 00-.243.193L5.5 3.75V6H4V3.75C4 2.784 4.784 2 5.75 2H8zm9.687 1.697a.252.252 0 00-.248 0l-.053.04-.796.795.946.947.82-.82a.248.248 0 00.043-.216l-.021-.053-.044-.06-.594-.593-.053-.04zM13 2v1.499L9.5 3.5V2H13z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var Layout = /*#__PURE__*/forwardRef(IconLayout);

export default Layout;
//# sourceMappingURL=Layout.js.map
